import React, {useCallback, useEffect} from 'react'
import { Grid, Box} from "@mui/material";
import { Breadcrumbs } from "../../../../Components";
import {useDispatch, useSelector,} from "react-redux";
import {fetchRoles, Sidebar, ViewRole} from '../index';
import {fetchPermissions} from "../../Permission";

export const Roles = () => {

    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = React.useState(false);
    const [alreadyFetchedPermissions, setAlreadyFetchedPermissions] = React.useState(false);
    const [, setErrors] = React.useState([]);
    const [, setMessage] = React.useState('');
    const [, setStatus] = React.useState('error');
    const items = useSelector((state => state.roles.list)) || [];

    const fetchRoleList = useCallback( async () => {
        setIsLoading(true);
        await fetchRoles({ dispatch, filters: {paginate:false, columns:['id','role_name','department'], withCount:'users'}}).then((res)=>{
            setIsLoading(false);
        });
    }, [dispatch]);

    useEffect(() => {
        fetchRoleList();
    },[fetchRoleList]);

    const fetchPermissionsList = useCallback(async () => {
        await fetchPermissions({ dispatch, filters: { paginate: false, columns: ['id', 'name', 'label','group','description'] } }).then((res) => {
            setErrors(res.errors);
            setMessage(res.message);
            setStatus(res.status)
        });
    },[dispatch]);

    useEffect(() => {
        if(!alreadyFetchedPermissions) {
            fetchPermissionsList();
            setAlreadyFetchedPermissions(true);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- run once on mount
    }, [fetchPermissionsList]);

    return (
        <Grid container spacing={3}>
            <Grid item xs={12}>
                <Box justifyContent={"space-between"} display={"flex"}>
                    <Breadcrumbs items={['DASHBOARD','ROLE']} />
                </Box>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={4} xl={3}>
                <Sidebar items={items} isLoading={isLoading} setIsLoading={setIsLoading}/>
            </Grid>
            <Grid item xs={12} sm={6} md={8} lg={8} xl={9}>
                <ViewRole />
            </Grid>
        </Grid>
    );
}
